import {useEffect, useState} from 'react';

interface IFullImageSwiper {
    isActive: boolean;
    isFullScreen: boolean;
    currentSlide: number;
    handleClose: () => void;
    handleClick: (index: number) => void;
}

export const useFullImageSwiper = (): IFullImageSwiper => {
    const [isActive, setActive] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);


    const handleClose = () => {
        setIsFullScreen(false);
    };

    const handleClick = (index: number) => {
        setIsFullScreen(true);
        setCurrentSlide(index);
    };

    useEffect(() => {
        setActive(isFullScreen);
    }, [isFullScreen]);

    useEffect(() => {
        if (isFullScreen) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'auto';
        }
    }, [isFullScreen]);

    return {handleClose, handleClick, isFullScreen, isActive, currentSlide};
}